import { render, staticRenderFns } from "./food-mune.vue?vue&type=template&id=6db92064"
import script from "./food-mune.vue?vue&type=script&lang=js"
export * from "./food-mune.vue?vue&type=script&lang=js"
import style0 from "./food-mune.vue?vue&type=style&index=0&id=6db92064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports